import * as React from 'react'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import getTitle from 'modules/documents/components/Documents/getTitle'
import EditFolderModal from 'modules/documents/components/Folders/Edit'
import RemoveFolderSubfolderModal from 'modules/documents/components/Folders/RemoveFolderSubfolderModal'
import OptionsButton from 'modules/documents/components/Settings/OptionsButton'
import { Folder } from 'modules/documents/hooks/useGetFolders'

interface Props {
  folder: Folder
  url: string
}

const FolderItem = ({ folder, url }: Props) => {
  const companyId = useCurrentSession().company.id
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false)
  const [renameModalOpen, setRenameModalOpen] = React.useState(false)
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen)
  const toggleRenameModal = () => setRenameModalOpen(!renameModalOpen)

  return (
    <Table.Row.Router to={url} key={folder.id}>
      <Table.Cell rowClickable colSpan={5}>
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Icon.Large icon={'folder'} color="grey600"></Icon.Large>
          <Text.Normal weight="medium" size="200" overflowWrap>
            {getTitle(folder.name)}
          </Text.Normal>
        </Box>
      </Table.Cell>
      <Table.Cell rowClickable={false} colSpan={1}>
        <Box flexDirection="row" justifyContent="flexEnd" padding="s16">
          <OptionsButton
            folder={folder}
            toggleRenameModal={toggleRenameModal}
            toggleDeleteModal={toggleDeleteModal}
          />
        </Box>
      </Table.Cell>
      {deleteModalOpen && (
        <RemoveFolderSubfolderModal
          folder={folder}
          onClose={toggleDeleteModal}
          companyId={companyId}
        />
      )}
      {renameModalOpen && (
        <EditFolderModal folder={folder} onClose={toggleRenameModal} companyId={companyId} />
      )}
    </Table.Row.Router>
  )
}
export default FolderItem
